import '../styles/Contacts.css';
import { Box, Paper, Stack, Typography } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import { useInView } from 'react-intersection-observer';

export default function Contacts() {
	const { ref: tollFreeRef, inView: tollFreeInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: localRef, inView: localInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: emailRef, inView: emailInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: addressRef, inView: addressInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	return (
		<div className="contact-page">
			<div className="page-banner-wrapper">
				<h2 className="page-banner-title">Contact Us</h2>
				<img
					className="page-banner"
					src="https://thehighpoint.s3.ca-central-1.amazonaws.com/high-point-resort-front-1.png"
					alt="Contact Us"
				/>
			</div>
			<Box
				className="contacts"
				container
				sx={{
					mx: 'auto',
					my: '32px',
					alignContent: 'center',
				}}
			>
				<Typography
					ref={tollFreeRef}
					className={`contact-link ${tollFreeInView ? 'animate__animated animate__fadeInUp' : ''}`}
					component="a"
					href="tel:+1-800-622-5311"
					align="center"
					sx={{
						lineHeight: '2',
						maxWidth: { xs: '279px', sm: 'none' },
						display: 'flex',
						justifyContent: 'center',
						mx: 'auto',
					}}
				>
					Toll-Free: 1-800-622-5311
				</Typography>
				<Typography
					ref={localRef}
					className={`contact-link ${localInView ? 'animate__animated animate__fadeInUp' : ''}`}
					component="a"
					href="tel:+1-250-285-2201"
					align="center"
					sx={{
						lineHeight: '2',
						maxWidth: { xs: '279px', sm: 'none' },
						display: 'flex',
						justifyContent: 'center',
						mx: 'auto',
					}}
				>
					Local: 250-285-2201
				</Typography>
				<Typography
					ref={emailRef}
					className={`contact-link ${emailInView ? 'animate__animated animate__fadeInUp' : ''}`}
					component="a"
					href="mailto:info@thehighpoint.ca"
					align="center"
					sx={{
						lineHeight: '2',
						maxWidth: { xs: '279px', sm: 'none' },
						display: 'flex',
						justifyContent: 'center',
						mx: 'auto',
					}}
				>
					Email: info@thehighpoint.ca
				</Typography>
				<Stack sx={{ mb: { xs: '32px', md: '64px' } }}>
					<Paper
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							boxShadow: 'none',
						}}
					></Paper>
					<Paper
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							boxShadow: 'none',
							mt: { xs: '16px', sm: '32px' },
							bgcolor: 'transparent',
						}}
					>
						<Stack
							sx={{
								fontSize: { xs: '0.8rem', sm: '1.125rem' },
								display: 'flex',
								alignItems: 'center',
							}}
						>
							<a
								ref={addressRef}
								className={`contact-map-link ${addressInView ? 'animate__animated animate__fadeInUp' : ''}`}
								href="https://maps.app.goo.gl/xBZjc2ZM1itpQBf16"
								target="_blank"
								rel="noopener noreferrer"
							>
								<span>High Point Resort</span>
								<span
									style={{
										display: 'flex',
										alignItems: 'center',
									}}
								>
									<PlaceIcon
										sx={{
											mx: { xs: 'none', sm: '5px' },
										}}
									/>
									725 Quathiaski Cove Rd, Quathiaski Cove, BC
								</span>
							</a>
						</Stack>
					</Paper>
				</Stack>
				<Typography
					ref={localRef}
					className={`contact-link ${localInView ? 'animate__animated animate__fadeInUp' : ''}`}
					component="a"
					href="tel:+1-250-285-2201"
					align="center"
					sx={{
						lineHeight: '2',
						maxWidth: { xs: '279px', sm: 'none' },
						display: 'flex',
						justifyContent: 'center',
						mx: 'auto',
						fontStyle: 'italic',
					}}
				>
					Check-in: 3:00 PM
				</Typography>
				<Typography
					ref={localRef}
					className={`contact-link ${localInView ? 'animate__animated animate__fadeInUp' : ''}`}
					component="a"
					href="tel:+1-250-285-2201"
					align="center"
					sx={{
						lineHeight: '2',
						maxWidth: { xs: '279px', sm: 'none' },
						display: 'flex',
						justifyContent: 'center',
						mx: 'auto',
						fontStyle: 'italic',
					}}
				>
					Check-out: 11:00 AM
				</Typography>
				<Typography
					ref={localRef}
					className={`contact-link ${localInView ? 'animate__animated animate__fadeInUp' : ''}`}
					component="a"
					href="tel:+1-250-285-2201"
					align="center"
					sx={{
						lineHeight: '2',
						maxWidth: { xs: '279px', sm: 'none' },
						display: 'flex',
						justifyContent: 'center',
						mx: 'auto',
						fontStyle: 'italic',
					}}
				>
					Sorry, we don't allow pets.
				</Typography>
			</Box>
		</div>
	);
}
